import { render, staticRenderFns } from "./TabUsers.vue?vue&type=template&id=3661fa11&"
import script from "./TabUsers.vue?vue&type=script&lang=js&"
export * from "./TabUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/piscinaFacilDev/piscinapp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3661fa11')) {
      api.createRecord('3661fa11', component.options)
    } else {
      api.reload('3661fa11', component.options)
    }
    module.hot.accept("./TabUsers.vue?vue&type=template&id=3661fa11&", function () {
      api.rerender('3661fa11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/places/tabs/TabUsers.vue"
export default component.exports